import Components from '../Components'
import type { RouteDefinitions } from '../Router'
import MyAccountRedirect from '../shared/MyAccountRedirect'
import HpSettingsRedirect from './HpSettingsRedirect'

const addressBookRoutes = {
  'address-book': {
    path: '/settings/business-profile/:accountId/address-book',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/business-profile/:accountId/address-book">
        <MyAccountRedirect paramName="accountId" validateExistingParam>
          <Components.AddressBook />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'address-book-details': {
    path: '/settings/business-profile/:accountId/address-book/:id',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/business-profile/:accountId/address-book/:id">
        <MyAccountRedirect paramName="accountId" validateExistingParam>
          <Components.AddressBookDetailsPage />
        </MyAccountRedirect>
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
} as const satisfies RouteDefinitions

export default addressBookRoutes
